import { avgPool } from '../../ops/avg_pool';
import { getGlobalTensorClass } from '../../tensor';
getGlobalTensorClass().prototype.avgPool = function (filterSize, strides, pad, dimRoundingMode) {
  this.throwIfDisposed();
  return avgPool(this, filterSize, strides, pad, dimRoundingMode);
};
